import { createSlice } from "@reduxjs/toolkit";

const initialQuizResults = {
  answers: "",
  results: [],
  resultsLoading: false,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const quizResultsSlice = createSlice({
  name: "quizResults",
  initialState: initialQuizResults,
  reducers: {
    // catchError: (state, action) => {
    //   // state.error = `${action.type}: ${action.payload.error}`;
    //   // if (action.payload.callType === callTypes.list) {
    //   //   state.listLoading = false;
    //   // } else {
    //   //   state.actionsLoading = false;
    //   // }
    // },
    startCall: (state, action) => {
      state.resultsLoading = true;
    },

    setAnswers: (state, action) => {
      const { answers } = action.payload;
      state.answers = answers;
    },

    resultsFetched: (state, action) => {
      const { results } = action.payload;
      console.log(results);
      state.resultsLoading = false;
      state.results = results;
    },

    resetAnswers: (state, action) => {
      state.answers = "";
    },
  },
});
